export const Info = ({ children }: React.PropsWithChildren) => (
  <div className="text-body-large text-content-light">{children}</div>
);
